"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInt = exports.convertChordsToNotes = exports.convertChordToNotes = exports.errorHasMessage = exports.flat = exports.dice = exports.pickOne = exports.sizzleMap = exports.shuffle = exports.expandStr = exports.isNote = void 0;
var harmonics_1 = require("harmonics");
/**
 * Take a string input and check if it s a note name or not
 * @param  {String} str Note name e.g. c4
 * @return {Boolean} Return true for c4 or return false for something like CM
 */
var isNote = function (str) {
    return /^[a-gA-G](?:#|b)?\d$/.test(str);
};
exports.isNote = isNote;
/**
 * Take a String input such as xxx[xx[xx]]
 * and return an Array as ['x', 'x', 'x', ['x', 'x', ['x', 'x']]]
 * @param  {String} str
 * @return {Array}
 */
var expandStr = function (str) {
    str = JSON.stringify(str.split(''));
    str = str.replace(/,"\[",/g, ', [');
    str = str.replace(/"\[",/g, '[');
    str = str.replace(/,"\]"/g, ']');
    return JSON.parse(str);
};
exports.expandStr = expandStr;
/**
 * Basic Array randomizer
 * @param  {Array} arr
 * @param  {boolean} fullShuffle Ensure no elements remain in old place
 * @return {Array}
 */
var shuffle = function (arr, fullShuffle) {
    if (fullShuffle === void 0) { fullShuffle = true; }
    var lastIndex = arr.length - 1;
    // Shuffle algorithm by Richard Durstenfeld (Donald E. Knuth), also Ronald Fisher and Frank Yates.
    // "Full Shuffle" Modification to ensure no elements remain in their original place (by taking each element once
    // and swapping with any remaining elements)
    arr.forEach(function (el, idx) {
        if (idx >= lastIndex) {
            // No shuffling last element
            // One before last is always swapped with last at the end of the loop
            // Since previous swaps can move last element into other places, there is still a random shuffle of last element
            return;
        }
        // Swap el with one of the higher elements randomly
        var rnd = fullShuffle
            ? // Pick random number from idx+1 to lastIndex (Modified algorithm, (N-1)! combinations)
                // Math.random -> [0, 1) -> [0, lastIndex-idx ) --floor-> [0, lastIndex-idx-1]
                // rnd = [0, lastIndex-idx-1] + 1 + idx = [1 + idx, lastIndex]
                // (Original algorithm would pick rnd = [idx, lastIndex], thus any element could arrive back into its slot)
                Math.floor(Math.random() * (lastIndex - idx)) + 1 + idx
            : // Pick random number from idx to lastIndex (Unmodified Richard Durstenfeld, N! combinations)
                Math.floor(Math.random() * (lastIndex + 1 - idx)) + idx;
        arr[idx] = arr[rnd];
        arr[rnd] = el;
    });
    return arr;
};
exports.shuffle = shuffle;
/**
 * Return an array of numbers relative to maxLevel || 127 ordered in a Sine wave format
 * This is used by the `sizzle` param of the `clip` method to add a rudimentary variation to the accent of each note
 * @param {Number} maxLevel A number between not more than 127
 * @return {Array}  Example output [63, 90, 110, 127, 110, 90, 63, 0, 63, 90, 110, 127, 110, 90, 63, 0]
 */
var sizzleMap = function (maxLevel) {
    if (maxLevel === void 0) { maxLevel = 127; }
    var pi = Math.PI;
    var piArr = [
        pi / 6,
        pi / 4,
        pi / 3,
        pi / 2,
        (2 * pi) / 3,
        (3 * pi) / 4,
        (5 * pi) / 6,
        pi,
    ];
    var piArrRev = [
        0,
        pi / 6,
        pi / 4,
        pi / 3,
        pi / 2,
        (2 * pi) / 3,
        (3 * pi) / 4,
        (5 * pi) / 6,
    ];
    piArrRev.reverse();
    var arr = piArr.concat(piArrRev);
    return arr.map(function (element) { return Math.round(Math.sin(element) * maxLevel); });
};
exports.sizzleMap = sizzleMap;
/**
 * Pick one item randomly from an array and return it
 * @param arr
 */
var pickOne = function (arr) {
    return arr.length > 1 ? arr[Math.round(Math.random())] : arr[0];
};
exports.pickOne = pickOne;
/**
 * Boolean generator
 */
var dice = function () { return !!Math.round(Math.random()); };
exports.dice = dice;
/**
 * Polyfill for Array.prototype.flat
 */
var flat = function (arr) {
    return arr.reduce(function (acc, val) { return acc.concat(val); }, []);
};
exports.flat = flat;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var errorHasMessage = function (x) {
    return typeof x.message === 'string';
};
exports.errorHasMessage = errorHasMessage;
/**
 *  'el' could be an inlineChord() e.g. Cmaj7 or Dbsus2_5
 *  or a chord() e.g. 'C3 M'
 */
var convertChordToNotes = function (el) {
    // Try both inlineChord() and chord()
    var c1;
    var c2;
    var e1;
    var e2;
    try {
        c1 = (0, harmonics_1.inlineChord)(el);
    }
    catch (e) {
        e1 = e;
    }
    try {
        c2 = (0, harmonics_1.chord)(el.replace(/_/g, ' ')); // chord() is not friendly to underscores
    }
    catch (e) {
        e2 = e;
    }
    if (!e1 && !e2) {
        // Both inlineChord() and chord() have result
        if (c1.toString() !== c2.toString()) {
            throw new Error("Chord " + el + " cannot decode, guessing " + c1 + " or " + c2);
        }
        return c1;
    } // else
    if (!e1) {
        return c1;
    } // else
    if (!e2) {
        return c2;
    } // else
    // Give up, last try:
    return (0, harmonics_1.chord)(el);
};
exports.convertChordToNotes = convertChordToNotes;
var convertChordsToNotes = function (el) {
    if (typeof el === 'string' && (0, exports.isNote)(el)) {
        // A note needs to be an array so that it can accomodate chords or single notes with a single interface
        return [el];
    }
    if (Array.isArray(el)) {
        // This could be a chord provided as an array or an array of arrays
        el.forEach(function (n) {
            // This could be a chord provided as an array
            if (Array.isArray(n)) {
                // TODO: Can we convert it to something useful?
                // make sure it uses valid notes
                n.forEach(function (n1) {
                    if (typeof n1 !== 'string' || !(0, exports.isNote)(n1)) {
                        throw new TypeError('array of arrays must comprise valid notes');
                    }
                });
                // throw new TypeError('cannot decode array of arrays');
            }
            else if (typeof n !== 'string' || !(0, exports.isNote)(n)) {
                // make sure it uses valid notes
                throw new TypeError('array must comprise valid notes');
            }
        });
        return el;
        // ? return el as (string | string[])[];
    }
    if (!Array.isArray(el)) {
        var c = (0, exports.convertChordToNotes)(el);
        if (c && c.length) {
            return c;
        }
    }
    throw new Error("Chord " + el + " not found");
};
exports.convertChordsToNotes = convertChordsToNotes;
var randomInt = function (num) {
    if (num === void 0) { num = 1; }
    return Math.round(Math.random() * num);
};
exports.randomInt = randomInt;
